import { Const } from "snudbud-backbone-sdk";

export type Goal = { value: Const.DailyGoal; label: string; description: string; icon: string };

export const GOALS: Goal[] = [
  { value: "small", label: "Casual", description: "5 minutes a day", icon: "🚶" },
  { value: "medium", label: "Committed", description: "10 minutes a day", icon: "🏃" },
  { value: "large", label: "Ambitious", description: "15 minutes a day", icon: "🚴" },
  { value: "extra-large", label: "Extreme", description: "20 minutes a day", icon: "🏆" },
];

interface StudyGoalSelectorProps {
  selectedGoal: Const.DailyGoal;
  onChange: (goal: Const.DailyGoal) => void;
}

export default function StudyGoalSelector({ selectedGoal, onChange }: StudyGoalSelectorProps) {
  return (
    <div className="space-y-3 sm:space-y-4">
      {GOALS.map((goal) => (
        <div
          key={goal.value}
          onClick={() => onChange(goal.value as Const.DailyGoal)}
          className={`flex items-center p-3 sm:p-4 border rounded-lg cursor-pointer transition-all ${
            selectedGoal === goal.value
              ? "border-blue-500 bg-blue-50"
              : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
          }`}
        >
          <div className="text-2xl sm:text-3xl mr-3 sm:mr-4">{goal.icon}</div>
          <div>
            <h3 className="font-medium text-base sm:text-lg">{goal.label}</h3>
            <p className="text-gray-600 text-xs sm:text-sm">{goal.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
